import {
	Breadcrumb,
	BreadcrumbItem,
	BreadcrumbLink,
	BreadcrumbList,
	BreadcrumbPage,
	BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';
import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from '@/components/ui/card';
import { Slash } from 'lucide-react';

import { PolicyTransactionsTable } from './table';

export function NorthlightPolicyTransactions() {
	const id = window.location.pathname.split('/').pop();
	const fileIngestionId = id ? parseInt(id) : NaN;
	return (
		<>
			<Breadcrumb className="mb-4 pl-4">
				<BreadcrumbList>
					<BreadcrumbItem>
						<BreadcrumbLink href="/northlight/policies">NorthLight Policy Feed</BreadcrumbLink>
					</BreadcrumbItem>
					<BreadcrumbSeparator>
						<Slash />
					</BreadcrumbSeparator>
					<BreadcrumbItem>
						<BreadcrumbPage>NorthLight Policy Transactions</BreadcrumbPage>
					</BreadcrumbItem>
				</BreadcrumbList>
			</Breadcrumb>

			<Card className="w-full">
				<CardHeader>
					<span className="flex flex-row justify-between">
						<CardTitle className="mt-2">NorthLight Policy Transactions</CardTitle>
					</span>
					<CardDescription>File Id {fileIngestionId}</CardDescription>
				</CardHeader>
				<CardContent className="space-y-2">
					<PolicyTransactionsTable fileIngestionId={fileIngestionId} />
				</CardContent>
			</Card>
		</>
	);
}
